// Executes a recommendation's `action` object exactly as the backend
// (recommendationEngine.js) describes it. This file contains NO recommendation
// decision logic — it only knows how to fulfil the three action types the
// backend currently emits, reusing the exact same start-practice/start-test
// call patterns already used by MockTest.js and TakeTest.js. When `action` is
// null (e.g. a behavioral_focus insight), there is nothing to run — the
// caller should not render a button at all rather than fabricate one.
export async function runRecommendationAction(action, { API, navigate }) {
  if (!action) return;

  if (action.type === 'start_practice') {
    const res = await API.post(action.endpoint, {
      ...action.params,
      session_type: 'recommended',
    });
    navigate('/student/mock/test', {
      state: {
        session_id: res.data.session_id,
        questions: res.data.questions,
        total: res.data.total,
        flowMode: 'recommended',
      },
    });
    return;
  }

  if (action.type === 'take_test') {
    // Real assigned test id, resolved server-side against actual assignments
    // — safe to route straight to the take-test screen.
    const match = action.endpoint.match(/\/tests\/([^/]+)\/student/);
    const testId = match?.[1];
    if (testId) navigate(`/student/test/${testId}`);
    return;
  }

  if (action.type === 'review_mistakes') {
    // MistakeBank.js has no topic filter today — link to the page as-is
    // rather than passing a filter param the page would silently ignore.
    navigate('/student/mistakes');
    return;
  }
}
